

















import { Component, Mixins } from 'vue-property-decorator'

import AppFieldInputCard from '@/components/AppFieldInputCard.vue'
import AppTitleBar from '@/components/AppTitleBar.vue'
import gql from 'graphql-tag'
import { UPDATE_USER } from '@/gql/user'
import { Common } from '@/mixins'

@Component({
  components: {
    AppFieldInputCard,
    AppTitleBar
  },
  apollo: {
    user: {
      query: gql`query userAtProfileDescription($targetUserId: Int) {
        user(targetUserId: $targetUserId) {
          id
          description
        }
      }`,
      result ({ data }) {
        this.newDescription = data.user.description
      }
    }
  }
})
export default class extends Mixins(Common) {
  user: { description?: string } = {}
  newDescription = ''

  async save () {
    const { data } = await this.$apollo.mutate({
      mutation: UPDATE_USER,
      variables: {
        input: {
          description: this.newDescription
        }
      }
    })
    await this.showToast(data.updateUser.message)
    await this.$router.back()
  }
}
